export const dataObligacionesE2026 = [
    {
      id: 1,
      fraccion: "A",
      titulo: "El listado de partidos políticos, asociaciones y agrupaciones políticas o de ciudadanos registrados ante la autoridad electoral",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "A-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx",
      excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02A_3.xlsx",
      excel4: "LTAIPT_A63F02A_4.xlsx", */
      managerId: 1,
    },
    {
      fraccion: "A-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_70_I_a.2.xlsx",
      /*excel2: "LTAIPT_A63F02B_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx", */
      managerId: 1,
    },
    {
      id: 2,
      fraccion: "B",
      titulo: "Los informes que presenten los partidos políticos, asociaciones y agrupaciones políticas o de ciudadanos",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "B-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx",
      excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02A_3.xlsx",
      excel4: "LTAIPT_A63F02A_4.xlsx", */
      managerId: 2,
    },
    {
      fraccion: "B-2",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02B_1.xlsx",
      excel2: "LTAIPT_A63F02B_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx", */
      managerId: 2,
    },
    {
      id: 4,
      fraccion: "D",
      titulo: "El registro de candidatos a cargos de elección popular",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "D-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx",*/
      managerId: 4,
    },
    {
      fraccion: "D-2",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02B_1.xlsx",*/
      managerId: 4,
    },
    {
      fraccion: "D-3",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx",*/
      managerId: 4,
    },
    {
      fraccion: "D-4",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02B_1.xlsx",*/
      managerId: 4,
    },

    {
      id: 5,
      fraccion: "E",
      titulo: "El catálogo de estaciones de radio y canales de televisión, pautas de transmisión, versiones de spots",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "E-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_70_I_e.1.xlsx",
      /*excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02A_3.xlsx",
      excel4: "LTAIPT_A63F02A_4.xlsx", */
      managerId: 5,
    },
    {
      fraccion: "E-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_70_I_e.2.xlsx",
      /*excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx", */
      managerId: 5,
    },
    {
      fraccion: "E-3",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_70_I_e.3.xlsx",
      /*excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02A_3.xlsx",
      excel4: "LTAIPT_A63F02A_4.xlsx", */
      managerId: 5,
    },
   
    {
      id: 6,
      fraccion: "F",
      titulo: "Los montos de financiamiento público por actividades ordinarias, de campaña y específicas otorgadas a los partidos políticos",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "F-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx", */
      managerId: 6,
    },
    {
      fraccion: "F-2",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02B_1.xlsx",
      excel2: "LTAIPT_A63F02B_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx",
      excel5: "LTAIPT_A63F02B_5.xlsx",
      excel6: "LTAIPT_A63F02B_6.xlsx",
      excel7: "LTAIPT_A63F02B_7.xlsx",
      excel8: "LTAIPT_A63F02B_8.xlsx",
      excel9: "LTAIPT_A63F02B_9.xlsx",
      excel10: "LTAIPT_A63F02B_10.xlsx",
      excel11: "LTAIPT_A63F02B_11.xlsx",
      excel12: "LTAIPT_A63F02B_12.xlsx", */
      managerId: 6,
    },

    {
      id: 8,
      fraccion: "H",
      titulo: "La metodología e informe del Programa de Resultados Preliminares Electorales",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "H-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx", */
      managerId: 8,
    },
    {
      fraccion: "H-2",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02B_1.xlsx", */
      managerId: 8,
    },

    {
      fraccion: "I",
      titulo: "Los cómputos totales de las elecciones y procesos de participación ciudadana llevados a cabo en el Estado",
      cumplimiento: "Aplica",
      /* excel1: "LTAIPT_A63F03_1.xlsx", */
      managerId: null,  
    },
    {
      fraccion: "J",
      titulo: "Los resultados y declaraciones de validez de las elecciones",
      cumplimiento: "Aplica",
      /* excel1: "LTAIPT_A63F03_1.xlsx", */
      managerId: null,  
    },
    {
      fraccion: "M",
      titulo: "Los dictámenes, informes y resoluciones sobre pérdida de registro y liquidación del patrimonio de los partidos políticos locales",
      cumplimiento: "Aplica",
      /* excel1: "LTAIPT_A63F03_1.xlsx",
       excel2: "LTAIPT_A63F03_2.xlsx",
       excel3: "LTAIPT_A63F03_3.xlsx",
       excel4: "LTAIPT_A63F03_4.xlsx",
        */
      managerId: null,  
    },
    
    {
      id: 14,
      fraccion: "N",
      titulo: "El monitoreo de medios.",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "N-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx", */
      managerId: 14,
    },
    {
      fraccion: "N-2",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx", */
      managerId: 14,
    },
    {
      fraccion: "N-3",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F02A_1.xlsx", */
      managerId: 14,
    },
    {
      fraccion: "N-4",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_70_I_n.4.xlsx",
      /*excel2: "LTAIPT_A63F02B_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx",
      excel5: "LTAIPT_A63F02B_5.xlsx",
      excel6: "LTAIPT_A63F02B_6.xlsx",
      excel7: "LTAIPT_A63F02B_7.xlsx",
      excel8: "LTAIPT_A63F02B_8.xlsx",
      excel9: "LTAIPT_A63F02B_9.xlsx",
      excel10: "LTAIPT_A63F02B_10.xlsx",
      excel11: "LTAIPT_A63F02B_11.xlsx",
      excel12: "LTAIPT_A63F02B_12.xlsx", */
      managerId: 14,
    },
  ];
  